import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M5 1.762a.75.75 0 00-.57.25C4.18 2.302 2 4.908 2 7c0 .774.267 1.5.752 2.045C3.14 9.48 3.843 10 5 10c1.969 0 3-1.509 3-3 0-2.092-2.183-4.698-2.43-4.988a.745.745 0 00-.57-.25zm6 4a.75.75 0 00-.57.25C10.18 6.302 8 8.908 8 11c0 .774.266 1.5.751 2.045C9.138 13.48 9.843 14 11 14c1.969 0 3-1.509 3-3 0-2.092-2.183-4.698-2.431-4.988a.745.745 0 00-.569-.25z" fill="#2e3436" /></svg>;
}

export default SvgComponent;